import React from 'react'
import { useCompany } from 'models';
import CardItem from './CardItem';
import Can from 'components/Can';
import { Col, Row } from 'react-bootstrap';
import * as reportsColor from 'images/reports-color.png'

export default function () {
  const { company } = useCompany();
  const { id: fiscalYear } = JSON.parse(localStorage.getItem("Elite:fiscalYear")) || {}

  const items = [    
    {
      permission: 'report.index',
      path: '/elite/reports',
      icon: reportsColor,
      title: 'Relatórios'
    }
  ]

  return (<>
    <Col sm="12" md="12" lg="12">
      <h6>Outros</h6>
    </Col>
    <Row>
      {items.map((item, idx) => {
        return (
          <Can do={item.permission} on="App" key={idx}>
            <CardItem item={item} className={item.old ? "card-old" : ""} />
          </Can>
        )
      })}
    </Row>
  </>)
}